import { AssociateAuditTrailService, IBaseAuditEvent } from '@amzn/ihm-associate-tools-js-lib'
import { generateDeferredPromise } from '@utils/DeferredPomiseUtil'

const AssociateToolsLoginMetricProperties = {
    LOGIN_PROCESS_NAME: 'AssociateToolsLogin',
    LOGOUT_PROCESS_NAME: 'AssociateToolsLogout',
    LOGIN_EVENT_TYPE: 'AssociateToolsLogin',
    LOGOUT_EVENT_TYPE: 'AssociateToolsLogout',
}

interface IAssociateLoginEvent extends IBaseAuditEvent {
    StoreId: string
    DevicePlatform: string
    DSN: string
}

export class AssociateToolsLoginAuditTrailService {
    public static emitAssociateToolsLoginEvent (storeId: string, devicePlatform: string, dsn: string) {
        Promise.resolve({}).then(() => {
            const baseAuditEvent = AssociateAuditTrailService.generateBaseEvent(
                AssociateToolsLoginMetricProperties.LOGIN_PROCESS_NAME,
            )
            const auditEvent: IAssociateLoginEvent = {
                ...baseAuditEvent,
                StoreId: storeId,
                DevicePlatform: devicePlatform,
                DSN: dsn,
            }
            AssociateAuditTrailService.recordEventAndEmitMetric(
                storeId, auditEvent, AssociateToolsLoginMetricProperties.LOGIN_EVENT_TYPE,
            ).catch((error) => {
                console.error('ATBase: Error recording login event to associate audit service: ' + error)
            })
        })
    }

    public static emitAssociateToolsLogoutEvent (storeId: string, devicePlatform: string, dsn: string) {
        const deferred = generateDeferredPromise<any>()

        Promise.resolve({})
            .then(() => {
                const baseAuditEvent = AssociateAuditTrailService.generateBaseEvent(
                    AssociateToolsLoginMetricProperties.LOGOUT_PROCESS_NAME,
                )
                const auditEvent: IAssociateLoginEvent = {
                    ...baseAuditEvent,
                    StoreId: storeId,
                    DevicePlatform: devicePlatform,
                    DSN: dsn,
                }
                console.debug('emitAssociateToolsLogoutEvent AssociateToolsLogout for device-' + dsn)
                AssociateAuditTrailService.recordEventAndEmitMetric(
                    storeId, auditEvent, AssociateToolsLoginMetricProperties.LOGOUT_EVENT_TYPE,
                )
                    .catch((error) => {
                        console.error(
                            'AssociateToolsLoginAuditTrailService: logout signal emit encountered an error ', error,
                        )
                    })
                    .finally(() => deferred.resolve({}))
            }).catch((error) => {
                console.info('ATBase: Error while emitting logout signal in AssociateTools tracking', error)
                return deferred.reject(error)
            })
        return deferred.promise
    }
}
